import { ActionTypes, TagCombinationActions } from './tag-combinations.actions';
import { TagCombinationState } from './tag-combinations.model';

export const tagCombinationState: TagCombinationState = {
  tableDataLoading: false,
  tableDataLoaded: false,
  tableData: [],
  tablePageInfo: {
    page: 1,
    pageCount: 0,
    total: 0,
  },
  getTagCombinationLoading: false,
  getTagCombinationLoaded: false,
  tagCombination: null,
  addTagCombinationLoading: false,
  addTagCombinationLoaded: false,
  editTagCombinationLoading: false,
  editTagCombinationLoaded: false,
  deleteTagCombinationsLoading: false,
  deleteTagCombinationsLoaded: false,
  destinationsDataLoading: false,
  destinationsDataLoaded: false,
  destinationsData: [],
  heartbeatSettingsDataLoading: false,
  heartbeatSettingsDataLoaded: false,
  heartbeatSettingsData: [],
  destinationMapDataLoading: false,
  destinationMapDataLoaded: false,
  destinationMapData: {},
};

export function tagCombinationReducer(
  state: TagCombinationState = tagCombinationState,
  action: TagCombinationActions,
): TagCombinationState {
  switch (action.type) {
    case ActionTypes.TAG_COMBINATIONS_DATA_LOADING:
      return {
        ...state,
        tableDataLoading: true,
        tableDataLoaded: false,
      };
    case ActionTypes.TAG_COMBINATIONS_DATA_LOADED:
      return {
        ...state,
        tableData: action.payload.data,
        tablePageInfo: {
          page: action.payload.page,
          pageCount: action.payload.pageCount,
          total: action.payload.total,
        },
        tableDataLoading: false,
        tableDataLoaded: true,
      };
    case ActionTypes.GET_TAG_COMBINATION:
      return {
        ...state,
        getTagCombinationLoading: true,
        getTagCombinationLoaded: false,
      };
    case ActionTypes.GET_TAG_COMBINATION_COMPLETED:
      return {
        ...state,
        tagCombination: action.payload.data,
        getTagCombinationLoading: false,
        getTagCombinationLoaded: true,
      };
    case ActionTypes.ADD_TAG_COMBINATION:
      return {
        ...state,
        addTagCombinationLoading: true,
        addTagCombinationLoaded: false,
      };
    case ActionTypes.ADD_TAG_COMBINATION_COMPLETED:
      return {
        ...state,
        addTagCombinationLoading: false,
        addTagCombinationLoaded: true,
      };
    case ActionTypes.EDIT_TAG_COMBINATION:
      return {
        ...state,
        editTagCombinationLoading: true,
        editTagCombinationLoaded: false,
      };
    case ActionTypes.EDIT_TAG_COMBINATION_COMPLETED:
      return {
        ...state,
        editTagCombinationLoading: false,
        editTagCombinationLoaded: true,
      };
    case ActionTypes.DELETE_TAG_COMBINATIONS:
      return {
        ...state,
        deleteTagCombinationsLoading: true,
        deleteTagCombinationsLoaded: false,
      };
    case ActionTypes.DELETE_TAG_COMBINATIONS_COMPLETED:
      return {
        ...state,
        deleteTagCombinationsLoading: false,
        deleteTagCombinationsLoaded: true,
      };
    case ActionTypes.DESTINATIONS_DATA_LOADING:
      return {
        ...state,
        destinationsDataLoading: true,
        destinationsDataLoaded: false,
      };
    case ActionTypes.DESTINATIONS_DATA_COMPLETED:
      return {
        ...state,
        destinationsData: action.payload,
        destinationsDataLoading: false,
        destinationsDataLoaded: true,
      };
    case ActionTypes.HEARTBEAT_SETTINGS_DATA_LOADING:
      return {
        ...state,
        heartbeatSettingsDataLoading: true,
        heartbeatSettingsDataLoaded: false,
      };
    case ActionTypes.HEARTBEAT_SETTINGS_DATA_COMPLETED:
      return {
        ...state,
        heartbeatSettingsData: action.payload,
        heartbeatSettingsDataLoading: false,
        heartbeatSettingsDataLoaded: true,
      };
    case ActionTypes.DESTINATION_MAP_DATA_LOADING:
      return {
        ...state,
        destinationMapDataLoading: true,
        destinationMapDataLoaded: false,
      };
    case ActionTypes.DESTINATION_MAP_DATA_COMPLETED:
      return {
        ...state,
        destinationMapData: action.payload,
        destinationMapDataLoading: false,
        destinationMapDataLoaded: true,
      };
    case ActionTypes.FETCH_ERROR:
      return {
        ...state,
      };
    default:
      return state;
  }
}
